import { getSelectors } from '@repo/core'
import { RootState } from '../../store/types'

const {
  payloadSelector: convenienceTestsDraftSelector,
  isLoadingSelector: convenienceTestsDraftIsLoadingSelector,
  hasErrorSelector: convenienceTestsDraftHasErrorSelector,
} = getSelectors({
  getRootPath: (state: RootState) => state.users.convenienceTestsDraft,
})

export const convenienceTestsDraftFetchStateSelector = (state: RootState) =>
  state.users.convenienceTestsDraft.meta.fetchState

export {
  convenienceTestsDraftHasErrorSelector,
  convenienceTestsDraftIsLoadingSelector,
  convenienceTestsDraftSelector,
}
